import { render, staticRenderFns } from "./WhereShipment.vue?vue&type=template&id=63f174f8&scoped=true"
import script from "./WhereShipment.vue?vue&type=script&lang=ts"
export * from "./WhereShipment.vue?vue&type=script&lang=ts"
import style0 from "./WhereShipment.vue?vue&type=style&index=0&id=63f174f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f174f8",
  null
  
)

export default component.exports